import React from 'react';
import { usePreventFocusOnClick } from '../../../../hooks/usePreventFocusOnClick';
import { WidgetSlideArrow } from '../../../../../Icons/dist';
import { widgetCarouselLeaveTimeout } from '../WidgetCarousel/WidgetCarousel';
import styles from './WidgetSlideDirectionButton.scss';

export enum WidgetSlideDirection {
  Forward = 'forward',
  Backward = 'backward',
}

interface WidgetSlideDirectionButtonProps {
  direction: WidgetSlideDirection;
  onClick: (direction: WidgetSlideDirection, event: React.MouseEvent) => void;
  dataHook?: string;
}

const buttonClickThreshold = 2 * widgetCarouselLeaveTimeout;

export const WidgetSlideDirectionButton: React.FC<WidgetSlideDirectionButtonProps> = ({
  direction,
  onClick,
  dataHook,
}) => {
  const preventFocusOnClick = usePreventFocusOnClick();
  const lastClickedTime = React.useRef<number>(null);
  const handleButtonClick = (event: React.MouseEvent) => {
    // prevent from clicking too fast
    if (lastClickedTime.current !== null && performance.now() - lastClickedTime.current < buttonClickThreshold) {
      return;
    }

    lastClickedTime.current = performance.now();
    onClick(direction, event);
  };

  const isForwardButton = direction === WidgetSlideDirection.Forward;

  return (
    <button
      className={isForwardButton ? styles.slideForwardButton : styles.slideBackwardButton}
      onClick={handleButtonClick}
      onFocus={preventFocusOnClick}
      data-hook={dataHook}
    >
      <WidgetSlideArrow className={isForwardButton ? styles.forwardIcon : styles.icon} />
    </button>
  );
};
